import React from 'react'
import { Row, Col, Collapse, Button } from 'reactstrap'
import cn from 'classnames'
import { currentStep } from 'utils/step_utils'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const ModuleHeaderBase = styled.div`
  transition: 0.2s;

  &:hover {
    ${props => props.status == 'completed' && `
      background: var(--bs-gray-300) !important;
    `}
  }
`

const ModulePanel = (props) => {
  const { children, status } = props
  return (
    <div
      className="module-panel mb-3" {...props}
    >
      {children}
    </div>
  )
}

const ModuleHeader = ({ status, children, onClick, showIcon = true }) => {
  return (
    <ModuleHeaderBase
      status={status}
      className={cn(
        "d-flex flex-row px-3 py-2 rounded-top",
        status === 'active' ? 'bg-active border border-bottom-0' : 'bg-light border-bottom-1 rounded',
      )}
      style={{ cursor: status !== 'active' ? 'pointer' : '' }}
      onClick={onClick}
    >
      <div
        className={cn(
          'module-header d-flex justify-content-between w-100 me-3',
          status === 'pending' ? 'fw-normal' : 'fw-semibold'
        )}
      >
        {children}
      </div>

      {showIcon && status === 'completed' && (
        <div
          className={cn(
            'd-flex justify-content-center align-items-center text-primary',
          )}
        >
          <i
            className={cn('fas fa-pencil-alt')}
            aria-hidden="true"
          />
        </div>
      )}
    </ModuleHeaderBase>
  )
}

const ModuleBody = ({ status, children, className }) => (
  <Collapse isOpen={status === 'active'}>
    <div
      style={{ background: 'white' }}
      className={
        className
          ? className
          : cn('p-3', 'border rounded-bottom')
      }
    >
      {children}
    </div>
  </Collapse>
)

const ModuleFooter = ({
  machine,
  status,
  stepConfig,
  isLastStep,
  children,
  className
}) => {
  const [current, send] = machine
  const { next_ready } = current.context
  const { i18n } = useTranslation()

  if (status !== 'active') return null

  if (stepConfig && !stepConfig.autoNext && !isLastStep) {
    return (
      <Row>
        <Col xs="12" md="2" className="offset-md-10 mt-3">
          <Button
            disabled={!next_ready}
            size="lg"
            color="primary"
            className="text-white w-100 rounded-5"
            onClick={() =>
              send('NEXT_STEP_CLICK', {
                currentStep: currentStep(current.value)
              })
            }
          >
            {i18n.t('module_footer.next_button')}
          </Button>
        </Col>
      </Row>
    )
  }

  return null
}

export { ModulePanel, ModuleHeader, ModuleBody, ModuleFooter }
